import AdminCompaniesGrid from "@/views/AdminCompaniesGrid.vue";
import msalApi from "../config/setupMSALAxios"; // your configured Axios instance
import { Guid } from "devextreme/common";

//#region USER CRUD Operations
export async function fetchActiveDirectoryUsers() {
  // No need to set headers if your interceptor handles it
  const response = await msalApi.get("/api/Admin/loadADUsers");
  return response.data;
}

// TODO
// Create (POST)
export async function createADUser(user) {
  const response = await msalApi.post("/api/Admin", user);
  return response.data;
}

// Update (PUT)
export async function updateADUser(id, user) {
  const response = await msalApi.put(`/api/Admin/${id}`, user);
  return response.data;
}

// Delete (DELETE)
export async function deleteADUser(id) {
  const response = await msalApi.delete(`/api/Admin/${id}`);
  return response.data;
}
//#endregion

// #region COMPANIES CRUD Operations
export async function fetchCompanies(id?: string) {
  // console.log("FOUND:", id);
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetCompany", config);
  return response.data;
}

export async function fetchCompanyApplications(id: string) {
  console.log(" API : FETCH > company ID TO FETCH APPLICATIONS", id);
  const response = await msalApi.get("/api/Admin/GetCompanyApplications", {
    params: {
      id: id,
    },
  });
  return response.data;
}

export async function putCompanyApplications(companyAppChanges: object) {
  console.log("API : UPDATE > company applications TO SEND", companyAppChanges);
  const response = await msalApi.put("/api/Admin/PutCompanyApplications", companyAppChanges);
  return response.data;
  // return true;
}

export async function fetchCompanyModules(id: string) {
  console.log(" API : FETCH > company ID TO FETCH MODULES", id);
  const response = await msalApi.get("/api/Admin/GetCompanyModules", {
    params: {
      id: id,
    },
  });
  return response.data;
}
export async function fetchCompanyModuleList(id: string) {
  console.log(" API : FETCH > company ID TO FETCH MODULE LIST", id);
  const response = await msalApi.get("/api/Admin/GetCompanyModuleList", {
    params: {
      id: id,
    },
  });
  return response.data;
}

export async function putCompanyModules(companyModuleChanges: object) {
  console.log("API : UPDATE > company modules TO SEND", companyModuleChanges);
  const response = await msalApi.put("/api/Admin/PutCompanyModules", companyModuleChanges);
  return response.data;
}

export async function fetchCompanyUELAs(id: string) {
  console.log(" API : FETCH > company ID TO FETCH UELAs", id);
  const response = await msalApi.get("/api/Admin/GetCompanyUELAs", {
    params: {
      id: id,
    },
  });
  return response.data;
}

export async function fetchCompanyModuleAppRoles(id: string) {
  console.log(" API : FETCH > company ID TO FETCH Module App Roles", id);
  const response = await msalApi.get("/api/Admin/GetModuleAppRoles", {
    params: {
      id: id,
    },
  });
  return response.data;
}

// ! NEW  fetchCompanyUsers
export async function fetchCompanyUsers(id: string) {
  console.log(" API : FETCH > company ID TO FETCH Users", id);
  const response = await msalApi.get("/api/Admin/GetCompanyUsers", {
    params: {
      id: id,
    },
  });
  return response.data;
}
export async function fetchNewCompanyUsers(id: string) {
  console.log(" API : FETCH > company ID TO FETCH          New Users", id);
  const response = await msalApi.get("/api/Admin/GetNewCompanyUsers", {
    params: {
      id: id,
    },
  });
  return response.data;
}
export async function fetchUsersRoles(companyId: string, objectId: string) {
  console.log(" API : FETCH > company ID TO FETCH          Users Roles", companyId);
  console.log(" API : FETCH > object ID TO FETCH          Users Roles", objectId);
  const response = await msalApi.get("/api/Admin/GetUsersRoles", {
    params: {
      companyId: companyId,
      objectId: objectId,
    },
  });
  return response.data;
}

export async function removeCompanyUser(userRemovePayload: object) {
  console.log("API : REMOVE > company user        ", userRemovePayload);
  const response = await msalApi.put("/api/Admin/RemoveCompanyUser", userRemovePayload);
  return response.data;
}

export async function putCompanyUsersAppRoles(usersAppRolesChanges: object) {
  console.log("API : UPDATE > company module app roles TO SEND", usersAppRolesChanges);
  const response = await msalApi.put("/api/Admin/PutCompanyUsersAppRoles", usersAppRolesChanges);
  return response.data;
}

// Create (POST)
export async function createCompany(company: object) {
  console.log("API : CREATE > company TO SEND", company);

  const response = await msalApi.post("/api/Admin/PostCompany", company);
  console.log("API :  response ");
  console.log(response.data);
  return response.data;
}

// & Update (PUT)
export async function updateCompany(company: object) {
  console.log("API : UPDATE > company TO SEND", company);

  const response = await msalApi.put(`/api/Admin/PutCompany`, company);
  console.log("API :  response ");
  console.log(response);

  return response.data;
}

// Delete (DELETE)
export async function deleteCompany(id: string) {
  console.log(" API : DELETE > company ID TO DELETE", id);
  const response = await msalApi.delete("/api/Admin/DeleteCompany", {
    params: {
      id: id,
    },
  });
  return response.data;
}

//#endregion

//#region APPLICATIONS CRUD Operations
export async function fetchApplications(id?: string) {
  // console.log("FOUND:", id);
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetApplication", config);
  return response.data;
}
// Create (POST)
export async function createApplication(application: object) {
  console.log("API : CREATE > application TO SEND", application);

  const response = await msalApi.post("/api/Admin/PostApplication", application);
  console.log("API :  response ");
  console.log(response.data);
  return response.data;
}

// Update (PUT)
export async function updateApplication(application: object) {
  const response = await msalApi.put(`/api/Admin/PutApplication`, application);
  console.log("API :  response ");
  console.log(response);

  return response.data;
}

// Delete (DELETE)
export async function deleteApplication(id: string) {
  console.log(" API : DELETE > application ID TO DELETE", id);
  const response = await msalApi.delete("/api/Admin/DeleteApplication", {
    params: {
      id: id,
    },
  });
  return response.data;
}

//#endregion

//#region MODULES CRUD Operations
export async function fetchModule(id?: string) {
  // No need to set headers if your interceptor handles it
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetModule", config);
  return response.data;
}
// Create (POST)
export async function createModule(module: object) {
  console.log("API : CREATE > module TO SEND", module);
  const response = await msalApi.post("/api/Admin/PostModule", module);
  return response.data;
}

// Update (PUT)
export async function updateModule(module: object) {
  const response = await msalApi.put(`/api/Admin/PutModule`, module);
  console.log("API :  response ");
  console.log(response);
}

// Delete (DELETE)
export async function deleteModule(id: string) {
  console.log(" API : DELETE > module ID TO DELETE", id);
  const response = await msalApi.delete("/api/Admin/DeleteModule", {
    params: {
      id: id,
    },
  });
  return response.data;
}

//#endregion

//#region APPROLES CRUD Operations
export async function fetchAppRole(id?: string) {
  // No need to set headers if your interceptor handles it
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetAppRole", config);
  return response.data;
}
export async function putCompanyModuleAppRoles(moduleAppRolesChanges: object) {
  console.log("API : UPDATE > company module app roles TO SEND", moduleAppRolesChanges);
  const response = await msalApi.put("/api/Admin/PutCompanyModuleAppRoles", moduleAppRolesChanges);
  return response.data;
}

// Create (POST)
export async function createAppRole(appRole: object) {
  console.log("API : CREATE > appRole TO SEND", appRole);
  const response = await msalApi.post("/api/Admin/PostAppRole", appRole);
  return response.data;
}

// Update (PUT)
export async function updateAppRole(appRole: object) {
  const response = await msalApi.put(`/api/Admin/PutAppRole`, appRole);
  console.log("API :  response ");
  console.log(response);
}

// Delete (DELETE)
export async function deleteAppRole(id: string) {
  console.log(" API : DELETE > appRole ID TO DELETE", id);
  const response = await msalApi.delete("/api/Admin/DeleteAppRole", { params: { id } });
  return response.data;
}

//#endregion

export async function fetchDXCodeMappings(id?: string) {
  // No need to set headers if your interceptor handles it
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetDXCodeMappings", config);
  return response.data;
}
export async function fetchDXCodeMappingDetail(id?: string) {
  // No need to set headers if your interceptor handles it
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetDXCodeMappingDetail", config);
  return response.data;
}

export async function fetchDXCodeMappingRXList(id?: string) {
  // No need to set headers if your interceptor handles it
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetDXCodeMappingRXList", config);
  return response.data;
}

export async function fetchDXCodeMappingRXListDetail(id?: string) {
  // No need to set headers if your interceptor handles it
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetDXCodeMappingRXListDetail", config);
  return response.data;
}

// Update (PUT)
export async function putDxMappingDetail(mapping: object) {
  const response = await msalApi.put(`/api/Admin/PostDXCodeMappingDetail`, mapping);
  console.log("API :  response ");
  console.log(response);
  return response.data;
}

export async function putDxMappingGroupDetail(mapping: object) {
  const response = await msalApi.put(`/api/Admin/PostDXCodeMappingGroupDetail`, mapping);
  console.log("API :  response ");
  console.log(response);
  return response.data;
}

export async function fetchDXCodeMappingGroupDetail(id?: string) {
  // No need to set headers if your interceptor handles it
  const config = id ? { params: { id } } : {};
  const response = await msalApi.get("/api/Admin/GetDXGroupMappingDetail", config);
  return response.data;
}
export async function createDXGroupMappingDetail(module: object) {
  console.log("API : CREATE > module TO SEND", module);
  const response = await msalApi.put("/api/Admin/PostDXGroupMappingDetail", module);
  return response.data;
}

// & ADMIN Dropdown Lists
export async function fetchDropdownFormLists() {
  const response = await msalApi.get("/api/Admin/GetDataForDropdownArrays");
  return response.data;
}
// Create (POST)
export async function createDropdownItem(item: object) {
  console.log("API : CREATE > dropdown item TO SEND", item);
  const response = await msalApi.post("/api/Admin/PostDropdownItem", item);
  return response.data;
}

// Update (PUT)
export async function updateDropdownItem(item: object) {
  const response = await msalApi.put(`/api/Admin/PutDropdownItem`, item);
  console.log("API :  response ");
  console.log(response);
  return response.data;
}


// PostDropdownItem  PutDropdownItem
export async function fetchDrugMasterList() {
  const response = await msalApi.get("/api/Admin/GetDrugMasterSearchList");
  return response.data;
}
